module.exports = __webpack_public_path__ + "img/gengshifu-xiaochengxu.44c81bdf.png";